import Pagination from '@/components/pagination/index.vue';
import Service from './e-commerce.service';
export default {
  components: {
    Pagination
  },
  data () {
    return {
      showDialog: false,
      brandList: [],
      cateCodeList: [{ name: '农机', id: '001' }, { name: '种子', id: '002' }, { name: '肥料', id: '003' }, { name: '农药', id: '004' }, { name: '农林产品', id: '005' }],
      priceList: [{ name: '50元以下', id: '' }, { name: '50元-100元', id: '' }, { name: '100元-150元', id: '' }, { name: '150元-200元', id: '' }, { name: '200元-300元', id: '' }, { name: '300元以上', id: '' }],
      total: 0,
      queryName: {},
      query: {
        pageNum: 1,
        pageSize: 8,
        brandId: '',
        cateCodeNew: '000',
        orderColumn: ''
      },
      activeType: '',
      list: [],
      tId: '66aaf784247b9fffdb5eba0b'
    };
  },

  created () {
    this.activeType = this.$route.query.type;
    this.getList();
    this.getTypeList();
  },

  watch: {
    $route (newRoute) {
      if (newRoute) {
        this.activeType = newRoute.query.type;
        this.resetQuery();
        this.getList();
        this.getTypeList();
      }
    }
  },
  methods: {
    getList (page) {
      if (page) {
        this.query.pageNum = page.pageNo;
        this.query.pageSize = 8;
      } else {
        this.query.pageNum = 1;
      }
      const obj = {};
      Object.keys(this.query).forEach(item => {
        if (this.query[item] && (this.query[item] !== 'all')) {
          obj[item] = this.query[item];
        }
      });
      this.getProductList(obj);
    },

    toDetail(id) {
      if (!id) return;
      this.$router.push('/socialized-service/e-commerce/detail?id=' + id);
    },

    getProductList (obj) {
      Service.getProductList({ tenantId: this.tId, ...obj }).then(res => {
        this.list = res.data.list;
        this.total = res.data.total;
      });
    },

    resetQuery () {
      this.query = {
        pageNum: 1,
        pageSize: 8,
        brandId: '',
        cateCodeNew: '000',
        orderColumn: ''
      };
      this.queryName = {};
      this.getList();
    },

    delquery (key, value) {
      this.query[value] = '';
      this.queryName[value] = '';
      this.getList();
    },

    getTypeList () {
      Service.getBrandList({ tId: this.tId }).then(res => {
        this.brandList = res.data;
      });
    },

    updateQueryParmas (type, item) {
      this.query[type] = item.type || item.id || item._id;
      this.queryName[type] = item.name || item.brandName;
      this.getList();
    },

    getTableListBySort (type) {
      if (type === 'orderColumn') {
        if (this.query.orderColumn === 'price asc') {
          this.query.orderColumn = 'price desc';
        } else {
          this.query.orderColumn = 'price asc';
        }
      }
      this.getList();
    },
    toOther(url){
      // console.log(url);
      this.$router.push(url);
    }
  }
};
